<app-widget [widget-meta]="data"
  hidehelp="false">
  @if (profileService.profile$ | async; as profile) {
    @if (links.data$ | async; as links) {
      <div>
        <div>
          <label for="filterLinks" class="sr-only">Type to filter the list</label>
          <input type="search" [(ngModel)]="filterText" (ngModelChange)="filterText$.next($event)" class="form-control" placeholder="Filter...">
        </div>
        <div class="d-flex justify-content-end mt-1">
          <button type="button" class="btn btn-explain text-primary small py-0" (click)="toggleGroups('collapse', links)">Collapse All</button><small>|</small>
          <button type="button" class="btn btn-explain text-primary small py-0" (click)="toggleGroups('expand', links)">Expand All</button><small>|</small>
          <button type="button" class="btn btn-explain text-primary small py-0" (click)="toggleGroups('favorites', links)">Expand Favorites</button>
        </div>
        @for (group of links | keyvalue; track group; let i = $index) {
          <div class="fw-bold pointer my-2" (click)="expandCollapse(i)">
            <i class="fa-regular text-warning" [ngClass]="isExpanded.includes(i) ? 'fa-folder-open' : 'fa-folder'"></i> {{group.key}} ({{group.value?.length}})
          </div>
          @if (isExpanded.includes(i)) {
            <div class="px-4">
              <ul>
                @for (item of group.value; track item) {
                  <li class="d-flex">
                    <div class="icon me-2" (click)="updateFavorite(profile.favorites, item)" [attr.aria-label]="profile.favorites.includes(item.Id) ? 'Favorite' : 'Not Favorite'">
                      <i class="fas fa-star" aria-hidden="true" [class.active]="profile.favorites.includes(item.Id)"
                      [title]="profile.favorites.includes(item.Id) ? 'Remove link from favorites?' : 'Favorite this link?'"></i>
                    </div>
                    <div>
                      <a href="{{item.Uri}}" target="_blank" (click)="linkClicked(item)">{{item.Title}}</a>
                      @if (!!item.Summary && (item.Summary != item.Title)) {
                        <div class="ms-2"><small>{{item.Summary}}</small></div>
                      }
                    </div>
                  </li>
                }
              </ul>
            </div>
          }
        }
      </div>
    } @else {
      <ng-template [ngTemplateOutlet]="loadingOrError.template"></ng-template>
    }
  } @else {
    <ng-template [ngTemplateOutlet]="loadingOrError.template"></ng-template>
  }

  <loading-or-error #loadingOrError
    [loadingWrapper]="links"
    [errorMessage]="'Oops! Looks like we can\'t get information for Links!'">
  </loading-or-error>
</app-widget>

